module.exports = __webpack_public_path__ + "static/img/placeholder-product.81aa9b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/placeholder-product.jpg
// module id = 6k7e
// module chunks = 8